export default {
  placeholder: 'Pesquisar marca...',
};
